import tmhRequest from '@/config/tmhRequest'

export default {
    searchEmployeeTransfer: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/searchemployeetransfer',
            method: 'post',
            params: data,
        })
    },
    searchEmployeeTransferCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/searchemployeetransfercount',
            method: 'post',
            data: data,
        })
    },

    searchEmployeeTransferByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/searchemployeetransferbypage',
            method: 'post',
            data: data,
        })
    },

    
    addEmployeeTransfer: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/addemployeetransfer',
            method: 'post',
            params: data,
        })
    },

    editEmployeeTransfer: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/editemployeetransfer',
            method: 'post',
            params: data,
        })
    },
    deleteEmployeeTransfer: function (data) {
        return tmhRequest({
            url: '/employee/tmh/employeetransfer/deleteemployeetransfer',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/employee/employeetransfer.js